import { ReactNode } from 'react';
import { tw } from '@/lib/tailwind';
import { Button } from '@alchemer/ui/components/button';
import { Check } from '@alchemer/ui/icons';

interface UserMenuDialogItemProps {
  label: string | undefined;
  subLabel?: string;
  icon?: ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  isSelected?: boolean;
}

export default function UserMenuDialogItem({
  label,
  subLabel,
  icon,
  onClick,
  ariaLabel,
  isSelected,
}: UserMenuDialogItemProps) {
  return (
    <li role="none">
      <Button
        variant="ghost"
        aria-label={ariaLabel || label}
        role="menuitem"
        className={tw(
          `flex h-full w-full cursor-pointer items-center gap-3 px-3 py-1.5`,
          `rounded-xs bg-white`,
          `group text-accent-foreground`,
          onClick ? 'hover:bg-background-100 cursor-pointer' : 'cursor-default hover:bg-white',
        )}
        onClick={onClick}
      >
        {icon && (
          <span
            className={tw(
              `text-muted-foreground`,
              `flex h-7 w-7 shrink-0 items-center justify-center`,
              onClick ? 'group-hover:text-accent-foreground' : '',
            )}
          >
            {icon}
          </span>
        )}
        <div className={tw('mr-auto flex min-w-0 flex-col items-start justify-center')}>
          <span className="text-accent-foreground text-sm font-semibold">{label}</span>
          {subLabel && (
            <span
              className={tw(
                `text-muted-foreground`,
                `text-[10px] font-normal`,
                onClick ? 'group-hover:text-accent-foreground' : '',
              )}
            >
              {subLabel}
            </span>
          )}
        </div>
        {isSelected && <span>{<Check className="h-4! w-4!" />}</span>}
      </Button>
    </li>
  );
}
